import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck, Zap, Users } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-16 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-139">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-140">
        <div className="absolute inset-0 bg-gradient-to-b from-warmBrown-dark/60 via-charcoal to-charcoal z-10" data-id="element-141" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(212,168,83,0.08)_0%,transparent_50%)] z-10" data-id="element-142" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-143">
        {/* Left — Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="space-y-7" data-id="element-144">
          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight" data-id="element-145">
            Aprendé a vender focaccias desde tu casa{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-146">
              y generar ingresos reales en 30 días
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl sm:text-2xl text-cream-muted font-light" data-id="element-147">
            Sin experiencia. Sin local. Con un método probado.
          </p>

          {/* Bullets */}
          <ul className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-x-6 sm:gap-y-3" data-id="element-148">
            {['Empezá desde tu casa', 'Inversión mínima', 'Sistema paso a paso'].map((item, i) => <li key={i} className="flex items-center gap-2.5 text-cream" data-id="element-149">
                <span className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-150">
                  <Check className="w-3.5 h-3.5 text-gold" strokeWidth={3} data-id="element-151" />
                </span>
                <span className="font-medium" data-id="element-152">{item}</span>
              </li>)}
          </ul>

          {/* Price + Urgency */}
          <div className="bg-warmBrown/40 border border-gold/20 rounded-2xl p-5 sm:p-6 space-y-4" data-id="element-153">
            <div className="flex items-baseline gap-3 flex-wrap" data-id="element-154">
              <span className="text-lg text-cream-muted/50 line-through" data-id="element-155">
                $29.980
              </span>
              <span className="text-4xl sm:text-5xl font-bold text-gold tracking-tight" data-id="element-156">
                $14.990
              </span>
              <span className="text-lg text-gold/80 font-medium" data-id="element-157">ARS</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm" data-id="element-158">
              <span className="inline-flex items-center gap-1.5 text-gold-light font-medium" data-id="element-159">
                <Zap className="w-4 h-4" data-id="element-160" />
                Precio de lanzamiento
              </span>
              <span className="text-cream-muted/60 hidden sm:inline" data-id="element-161">·</span>
              <span className="text-cream-muted/80" data-id="element-162">
                Disponible solo para las primeras 50 alumnas
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <div className="space-y-4" data-id="element-163">
            <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 w-full sm:w-auto text-lg font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_30px_rgba(212,168,83,0.35)] hover:shadow-[0_0_50px_rgba(212,168,83,0.55)]" data-id="element-164">
              <span className="relative z-10 flex items-center gap-2" data-id="element-165">
                QUIERO EMPEZAR MI NEGOCIO HOY
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-166" />
              </span>
              <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-167" />
            </motion.a>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-cream-muted/70" data-id="element-168">
              <span className="flex items-center gap-1.5" data-id="element-169">
                <Users className="w-4 h-4 text-gold/60" data-id="element-170" />
                +200 personas ya empezaron
              </span>
              <span className="flex items-center gap-1.5" data-id="element-171">
                <Zap className="w-4 h-4 text-gold/60" data-id="element-172" />
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-173">
                <ShieldCheck className="w-4 h-4 text-gold/60" data-id="element-174" />
                Pago seguro
              </span>
            </div>
          </div>
        </motion.div>

        {/* Right — Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        x: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative mt-8 lg:mt-0" data-id="element-175">
          <div className="absolute inset-0 bg-gold/15 blur-[60px] rounded-full pointer-events-none" data-id="element-176" />
          <img src="https://cdn.magicpatterns.com/uploads/gDiKgucRP1T9Z2624efsfk/ChatGPT_Image_31_mar_2026,_10_53_59_a.m..png" alt="Ebook Emprendé con Focaccias" className="relative z-10 w-full h-auto rounded-3xl shadow-[0_0_40px_rgba(0,0,0,0.5)] border border-white/10 object-contain" data-id="element-177" />
        </motion.div>
      </div>
    </section>;
}